// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__pdcfJ","basic":"Alert_basic__1Tz9A","info":"Alert_info__26x_D","pass":"Alert_pass__1S_kj","warn":"Alert_warn__2G0_j","fail":"Alert_fail__3UXuE"};